import * as yup from "yup";

const SelectMessage = "Escolha uma das opções.";
const PhoneNumberMessage = "Informe um número válido.";
const CheckBoxMessage =
  "Para prosseguir, é preciso que você aceite as duas opções apresentadas.";
const DataTypeErrorMessage = "A data deve ser válida";
const DateMessage = "Informe uma data válida.";
const MaxDateMessage = "Não é permitido inserir uma data futura.";
const CPFMessage = "Informe um CPF válido.";
const EmailMessage = "E-mail é obrigatório";
const EmailInvalidMessage = "Informe um e-mail válido.";
const NameMessage = "Informe um Nome.";

export const SchemaFormMIPStepOneInsured = yup.object().shape({
  CPF: yup.string().required(CPFMessage),
  IncidentDate: yup
    .date()
    .typeError(DataTypeErrorMessage)
    .max(new Date(), MaxDateMessage)
    .required(DateMessage),
  SelectCauseIncident: yup.string().required(SelectMessage),
  Email: yup.string().email(EmailInvalidMessage).required(EmailMessage),
  PhoneNumber: yup.string().required(PhoneNumberMessage),
  SelectFeedBack: yup.string().required(SelectMessage),
  Message: yup.string(),
  CorrectData: yup.bool().oneOf([true], CheckBoxMessage),
  AwareInformation: yup.bool().oneOf([true], CheckBoxMessage),
});

export const SchemaFormMIPStepOneCommunicatorWithContact = yup.object().shape({
  CPFCommunicator: yup.string().required(CPFMessage),
  NameCommunicator: yup.string().required(NameMessage),
  SelectCauseIncident: yup.string().required(SelectMessage),
  CPFInsured: yup.string().required(CPFMessage),
  IncidentDate: yup
    .date()
    .typeError(DataTypeErrorMessage)
    .max(new Date(), MaxDateMessage)
    .required(DateMessage),
  SelectFeedBack: yup.string().required(SelectMessage),
  DegreeOfKinship: yup.string().required(SelectMessage),
  PhoneNumber: yup.string().required(PhoneNumberMessage),
  AwareInformation: yup.bool().oneOf([true], CheckBoxMessage),
  PhoneNumberContact: yup.string().required(PhoneNumberMessage),
  Message: yup.string(),
  Email: yup.string().email(EmailInvalidMessage).required(EmailMessage),
  CorrectData: yup.bool().oneOf([true], CheckBoxMessage),
  EmailContact: yup.string().email(EmailInvalidMessage).required(EmailMessage),
  NameContact: yup.string().required(NameMessage),
});

export const SchemaFormMIPStepOneCommunicator = yup.object().shape({
  DegreeOfKinship: yup.string().required(SelectMessage),
  CPFCommunicator: yup.string().required(CPFMessage),
  Message: yup.string(),
  PhoneNumber: yup.string().required(PhoneNumberMessage),
  SelectCauseIncident: yup.string().required(SelectMessage),
  NameCommunicator: yup.string().required(NameMessage),
  CPFInsured: yup.string().required(CPFMessage),
  Email: yup.string().email(EmailInvalidMessage).required(EmailMessage),
  SelectFeedBack: yup.string().required(SelectMessage),
  AwareInformation: yup.bool().oneOf([true], CheckBoxMessage),
  CorrectData: yup.bool().oneOf([true], CheckBoxMessage),
  IncidentDate: yup
    .date()
    .typeError(DataTypeErrorMessage)
    .max(new Date(), MaxDateMessage)
    .required(DateMessage),
});
